import { Routes } from '@angular/router';

export const platformContentRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('../../pages/platform-content/platform-content').then((m) => m.PlatformContent),
      },
      {
        path: 'categories-subcategories',
        loadComponent: () =>
          import('../../pages/platform-content/cat-subcat/cat-subcat').then((m) => m.CatSubcat),
      },
      {
        path: 'skills',
        loadComponent: () => import('./skills/skills').then((m) => m.Skills),
      },
      {
        path: 'tags',
        loadComponent: () => import('./tags/tags').then((m) => m.Tags),
      },
      {
        path: 'testimonials',
        loadComponent: () => import('./testimonials/testimonials').then((m) => m.Testimonials),
      },
      {
        path: 'tips-and-guides',
        loadComponent: () =>
          import('./tips-and-guides/tips-and-guides').then((m) => m.TipsAndGuides),
      },
      {
        path: 'faqs',
        loadComponent: () => import('../../pages/platform-content/faqs/faqs').then((m) => m.FAQS),
      },
      {
        path: 'terms-and-conditions',
        loadComponent: () =>
          import('./terms-and-conditions/terms-and-conditions').then((m) => m.TermsAndConditions),
      },
      {
        path: 'privacy-policy',
        loadComponent: () => import('./privacy-policy/privacy-policy').then((m) => m.PrivacyPolicy),
      },
      {
        path: 'social-media-links',
        loadComponent: () =>
          import('./social-media-links/social-media-links').then((m) => m.SocialMediaLinks),
      },
      {
        path: 'how-it-works',
        loadComponent: () => import('./how-it-works/how-it-works').then((m) => m.HowItWorks),
      },

      {
        path: 'language',
        loadComponent: () => import('./language/language').then((m) => m.Language),
      },
    ],
  },
];
